/* eslint-disable */
export default {
  removeParticipant: '참가자 제거',
  confirmStr1: '이 통화에서',
  confirmStr2: '제거하시겠습니까?',
  remove: '삭제',
  cancel: '취소',
  participants: '참가자',
  participant: '참가자',
  conferenceCall: '전화 회의',
  unknownNumber: '익명',
} as const;

// @key: @#@"removeParticipant"@#@ @source: @#@"Remove Participant"@#@
// @key: @#@"confirmStr1"@#@ @source: @#@"Are you sure you want to remove"@#@
// @key: @#@"confirmStr2"@#@ @source: @#@"from this call?"@#@
// @key: @#@"remove"@#@ @source: @#@"Remove"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"participants"@#@ @source: @#@"Participants"@#@
// @key: @#@"participant"@#@ @source: @#@"Participant"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
